import { Injectable } from '@angular/core';
import { ActivityInternalListComponent, Customer, CustomerContactListComponent, CustomerContactsGungListComponent, CustomerDetailsConfigService, CustomerDetailsTab, CustomerOrderFinderComponent, CustomerUserListComponent, ReturnWarrantyListComponent } from 'gung-standard';
import { JeevesClaimListComponent } from '../components/jeeves-claim-list/jeeves-claim-list.component';
import { GungUser as User } from 'gung-standard';
import { Observable, of, switchMap } from 'rxjs';
import { JeevesCustomerDetailsInfoTabComponent } from '../components/jeeves-customer-details-info-tab/jeeves-customer-details-info-tab.component';
import { JeevesCustomerDetailsBillingTabComponent } from '../components/jeeves-customer-details-billing-tab/jeeves-customer-details-billing-tab.component';
import { JeevesCustomerDetailsDeliveryLocationListComponent } from '../components/jeeves-customer-details-delivery-location-list/jeeves-customer-details-delivery-location-list.component';
import { JeevesInvoiceListComponent } from '../components/jeeves-invoice-list/jeeves-invoice-list.component';

@Injectable({
  providedIn: 'root'
})
export class JeevesCustomerDetailsConfigService extends CustomerDetailsConfigService {
  getCustomerDetailsGungTabs(customer: Customer, roles: string[], user?: User): Observable<CustomerDetailsTab[]> {
    const isUser: boolean = roles.indexOf('USER') !== -1 && roles.indexOf('ADMIN') === -1 && roles.indexOf('SALES') === -1;
    const isActuator: boolean = roles.indexOf('ACTUATOR') !== -1;

    return super.getCustomerDetailsGungTabs(customer, roles, user).pipe(
      switchMap((tabs) => {
        const addressTabIndex: number = tabs.findIndex(t => t.id === 'tab-info');
        if (addressTabIndex > -1) {
          const newAddressTab: CustomerDetailsTab = {
            id: 'tab-info',
            name: 'ADDRESS',
            component: JeevesCustomerDetailsInfoTabComponent,
            icon: 'fa-solid fa-address-card',
            componentInputParams: { customer: customer },
            sort: 100
          };
          tabs.splice(addressTabIndex, 1, newAddressTab);
        }

        tabs.push({
          id: 'tab-delivery-address',
          name: 'DELIVERY_ADDRESS',
          component: JeevesCustomerDetailsDeliveryLocationListComponent,
          icon: 'fa-solid fa-wrench',
          componentInputParams: { customer: customer },
          sort: 110
        });

        tabs.push({
          id: 'tab-billing',
          name: 'BILLING_INFORMATION',
          component: JeevesCustomerDetailsBillingTabComponent,
          icon: 'fa-solid fa-address-card',
          componentInputParams: { customer: customer },
          sort: 120
        });

        tabs.push({
          id: 'tab-contacts',
          name: 'CONTACTS',
          component: CustomerContactListComponent,
          icon: 'fa-solid fa-address-book',
          sort: 130
        });

        // Remove standard activities if found
        const activitiesTabIndex: number = tabs.findIndex(t => t.id === 'tab-activities');
        if (activitiesTabIndex > -1) {
          tabs.splice(activitiesTabIndex, 1);
        }

        if (isActuator) {
          tabs.push({
            id: 'tab-activities',
            name: 'ACTIVITIES',
            component: ActivityInternalListComponent,
            icon: 'fa-solid fa-handshake',
            componentInputParams: { customerId: customer.id, topFilter: true },
            sort: 140
          });
        }

        // Change standard analytics sort to 150
        const analyticsTabIndex: number = tabs.findIndex(t => t.id === 'tab-order-analytics');
        if (analyticsTabIndex > -1) {
          tabs[analyticsTabIndex].sort = 150;
        }

        const orderFinderTabIndex: number = tabs.findIndex(t => t.id === 'tab-order-finder');
        if (orderFinderTabIndex > -1) {
          tabs[orderFinderTabIndex].sort = 160;
        }

        // Remove standard offers if found
        const offersTabIndex: number = tabs.findIndex(t => t.id === 'tab-offers');
        if (offersTabIndex > -1) {
          tabs.splice(offersTabIndex, 1);
        }

        // Change standard invoices tab component to jeeves incoice3s component
        const invoicesTabIndex: number = tabs.findIndex(t => t.id === 'tab-invoices');
        if (invoicesTabIndex > -1) {
          tabs[invoicesTabIndex].component = JeevesInvoiceListComponent;
        }

        if (this.navbarConfigService.enableWarrantyClaims) {
          tabs.push({
            id: 'tab-warranty-claims',
            name: 'RETURN_WARRANTY',
            component: ReturnWarrantyListComponent,
            icon: 'fa-solid fa-award',
            componentInputParams: { customerId: customer.id },
            sort: 310
          });
        }

        if (this.navbarConfigService.enableJeevesClaims) {
          tabs.push({
            id: 'tab-claims',
            name: 'CLAIMS',
            component: JeevesClaimListComponent,
            icon: 'fa-solid fa-award',
            componentInputParams: { customerId: customer.id },
            sort: 320
          });
        }

        tabs.push({
          id: 'tab-users',
          name: 'USERS',
          component: CustomerUserListComponent,
          icon: 'fa-solid fa-address-book',
          sort: 330
        });

        return of(tabs);
      })
    );
  }
}
